import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import ErrorBoundaryContainer from '../../components/ErrorBoundaryContainer';
import Loading from '../../components/Loading';

import accountRouter from '../account';

const PageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "dasvistapro-dashboard-page" */ '../../pages/dasvistapro-dashboard/index'
    ),
);

const dasVistaProDashboardRouter = (
  <Route path="dasvistapro-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <ErrorBoundaryContainer
            key="dasvistapro-dashboard"
            component={<PageComponent />}
          />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default dasVistaProDashboardRouter;
